module.exports = __webpack_public_path__ + "static/img/46.9018bed8.png";